import React from 'react';

type YoutubePlayerProps = {
  id: string;
  isMobile: boolean;
};

const YoutubePlayer = (props: YoutubePlayerProps) => {
  const { w, h } = props.isMobile
    ? { w: '426', h: '240' }
    : { w: '640', h: '360' };

  return (
    <div className="video">
      <iframe
        width={w}
        height={h}
        src={`https://www.youtube.com/embed/${props.id}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default YoutubePlayer;
